import UpdateArticle from './UpdateArticle'
export default UpdateArticle
